import { useMemo } from 'react'
import { useListBrands } from 'services/products'

export interface BrandOption {
  label: string
  value: number
}

/**
 * Shared hook for fetching brand options formatted for dropdowns/comboboxes.
 * Centralizes the fetch + map pattern used across brand selectors, filters, and bulk actions.
 */
export function useBrandOptions(enabled: boolean = true) {
  const { data: brandsData, isLoading } = useListBrands(
    {
      page: 1,
      page_size: 1000,
      sort: 'name',
    },
    { query: { enabled } }
  )

  const brandOptions = useMemo<BrandOption[]>(() => {
    if (!brandsData?.results) return []
    return brandsData.results.map((brand) => ({
      label: brand.name,
      value: brand.id,
    }))
  }, [brandsData])

  return { brandOptions, isLoading }
}
